<!--<h4>GraphQl Data Source</h4>-->



<!--<mat-form-field appearance="fill" style="width:100%;">
  <mat-label>Data Source Type</mat-label>
  <mat-select [(value)]="dataSource.type">
    <mat-option>None</mat-option>
    <mat-option *ngFor="let type of EveReportingWidgetDataSourceType | keyvalue" [value]="type.key">{{type.key}}</mat-option>
  </mat-select>
</mat-form-field>-->





<div class="dataSourceComponent-container">
  <ng-container *ngIf="dataSource.type == EveReportingWidgetDataSourceType.GraphQl">

    <widget-graphql-datasource [dataSource]="dataSource"></widget-graphql-datasource>
  </ng-container>

  <ng-container *ngIf="dataSource.type == EveReportingWidgetDataSourceType.EveMultiChart">

    <widget-multi-datasource [dataSource]="dataSource"></widget-multi-datasource>
  </ng-container>

  <ng-container *ngIf="dataSource.type == EveReportingWidgetDataSourceType.EveSingleChart">

    <widget-single-datasource [dataSource]="dataSource"></widget-single-datasource>
  </ng-container>
</div>


